import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryParam = (name: string) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let param = searchParams.get(name);

    if (!window.location.search) {
        param = '';
    }

    return useMemo(() => param || '', [param]);
};

export default useQueryParam;
